import React from 'react';
import { createGlobalStyle, ThemeProvider as SCThemeProvider } from 'styled-components';
import defaultTheme from './theme';
import antdStyleOverwrites from './styles/antd';
import phoneInputStyleOverwrites from './styles/phone-input';
import animationStyles from './styles/animations';
import { color } from './mixins';
const GlobalStyles = createGlobalStyle `
	html, body, #__next {
		min-height: 100%;
	}

	a, a:hover {
		color: ${color('primary')};
	}

	::selection {
		background: ${color('primary')};
	}

	${antdStyleOverwrites}
	${phoneInputStyleOverwrites}
	${animationStyles}
`;
const ThemeProvider = ({ children }) => {
    return (React.createElement(SCThemeProvider, { theme: defaultTheme },
        React.createElement(GlobalStyles, null),
        children));
};
export default ThemeProvider;
